import React from 'react';
import { Grid, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { CREW_CLEARANCE_CONFIG } from '../../utils/crewClearance';

const CrewClearanceFields = ({ formData, onChange, showNotSpecified = false }) => (
  <>
    {CREW_CLEARANCE_CONFIG.map(({ field, formLegend }) => (
      <Grid item xs={12} md={6} key={field}>
        <FormControl component="fieldset">
          <FormLabel component="legend">
            {formLegend}
            {showNotSpecified ? ' (optional)' : ''}
          </FormLabel>
          <RadioGroup row value={formData[field]} onChange={onChange(field)}>
            {showNotSpecified && (
              <FormControlLabel value="" control={<Radio />} label="Not specified" />
            )}
            <FormControlLabel value="yes" control={<Radio />} label="Yes" />
            <FormControlLabel value="no" control={<Radio />} label="No" />
          </RadioGroup>
        </FormControl>
      </Grid>
    ))}
  </>
);

export default CrewClearanceFields;
